import { useEffect, useState } from 'react'
import { useUser, useApp } from '@/store'
import { errorLog } from '@/utils'

export const useOperatorAuth = () => {
  const [isOperator, setIsOperator] = useState<boolean>(false)
  const [loading, setLoading] = useState(true)
  const { user, isAuth } = useUser()
  const http = useApp.getState().http

  useEffect(() => {
    const checkOperatorAccess = async () => {
      // Default to not operator
      setIsOperator(false)

      if (!isAuth || !user?.email) {
        setLoading(false)
        return
      }

      try {
        // Try to search for the user's own email to verify operator access
        await http.get(`/operator/user?email=${encodeURIComponent(user.email)}`)
        // Only set to true if the API call succeeds
        setIsOperator(true)
      } catch (error) {
        errorLog(error)
        // Any error means not an operator (stays false)
        setIsOperator(false)
      } finally {
        setLoading(false)
      }
    }

    checkOperatorAccess()
  }, [isAuth, user, http])

  // Check if user can give bonus points (only @andrena.com and @dawninternet.com)
  const canGiveBonusPoints =
    isOperator &&
    user?.email &&
    (user.email.endsWith('@andrena.com') || user.email.endsWith('@dawninternet.com'))

  return { isOperator, loading, canGiveBonusPoints }
}

